import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      applyStatus: localStorage.getItem('applyStatus') || 'Submit',
      notaryRights: (() => {
          try {
              return JSON.parse(localStorage.getItem('notaryRights'));
          } catch (e) {
              return {};
          }
      })(),
      notaryInfo:(() => {
          try {
              return JSON.parse(localStorage.getItem('notaryInfo'));
          } catch (e) {
              return {};
          }
      })(),
  },
  mutations: {
      setApplyStatus(state, status) {
        state.applyStatus = status;
        localStorage.setItem('applyStatus', status);
      },
      setNotaryRights(state, rights) {
          state.notaryRights = rights;
          localStorage.setItem('notaryRights', JSON.stringify(rights));
      },
      setNotaryInfo(state, notary) {
          state.notaryInfo = notary;
          localStorage.setItem('notaryInfo', JSON.stringify(notary));
      }
  },
  actions: {
  },
  modules: {
  }
})
